import { fetchConcludedOrders } from '../api';
import { ordersHistoryEmptyMessages } from '../config';
import { prepareOrdersHistoryList } from './orders-history-list';
import { Env } from '@/shared/config/environment';

const state = {
  ordersList: [],
  ordersHistoryList: null,
  isLoadingOrders: false,
  ordersError: null,
};

const mutations = {
  SET_ORDERS_LIST(state, ordersList) {
    state.ordersList = ordersList;
  },
  SET_LOADING_ORDERS(state, isLoading) {
    state.isLoadingOrders = isLoading;
  },
  SET_ORDERS_ERROR(state, error) {
    state.ordersError = error;
  },
  SET_ORDERS_HISTORY_LIST(state, ordersHistoryList) {
    state.ordersHistoryList = ordersHistoryList;
  },
};

const actions = {
  async fetchOrdersList({ commit, dispatch }) {
    commit('SET_LOADING_ORDERS', true);
    commit('SET_ORDERS_ERROR', null);
    commit('SET_ORDERS_LIST', []);

    try {
      const orders = await fetchConcludedOrders();
      commit('SET_ORDERS_LIST', orders);

      const historyList = prepareOrdersHistoryList(orders);
      commit('SET_ORDERS_HISTORY_LIST', historyList);
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося отримати історію замовлень';

      commit('SET_ORDERS_ERROR', errorMessage);
      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося завантажити історію замовлень',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_ORDERS', false);
    }
  },
};

const getters = {
  isLoadingOrders: (state) => state.isLoadingOrders,
  ordersError: (state) => state.ordersError,
  isOrdersDataReady: (state) => state.isLoadingOrders === false && state.ordersHistoryList !== null && state.sales !== null,
  isEmpty: (state) => state?.ordersHistoryList?.length === 0,
  getEmptyMessage: () => ordersHistoryEmptyMessages[0],
  getOrdersHistoryList: (state) => state.ordersHistoryList,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
